import { MessageSquare, Sparkles, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateTicketPrioritizationBasedOnItsContentAr: TemplateAr = {
  name: 'أتمتة تحديد أولوية التذكرة بناءً على محتواها بالذكاء الاصطناعي',
  shortName: 'أتمتة تحديد أولوية التذاكر بالذكاء الاصطناعي',
  description:
    'اضبط مستويات أولوية التذاكر تلقائياً بتحليل الاستعجال وقيمة العميل وخطورة المشكلة من داخل المحادثة نفسها.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: Sparkles, label: 'الـ AI يقيّم' },
    { icon: Star, label: 'الأولوية محدّدة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اضبط أولوية كل تذكرة من محتواها، مو من كلمة «عاجل» في العنوان. الـ AI يقيّم المشاعر وحدّة اللغة والأثر على العمل ومتطلبات SLA عشان يعطي مستوى أولوية دقيق. ويضمن إن المشكلات الحرجة تحظى باهتمام فوري، ويمنع في نفس الوقت تضخّم الأولويات.',
    paragraph2:
      'الأولوية تتزامن مباشرة مع نظام التذاكر عندك، وتشغّل قواعد التوجيه وSLA المناسبة. وأنماط الأولوية ومؤشرات الدقة توصل لأدوات التحليلات عندك عشان تتابعها. والـ AI يتعلّم من نتائج الحل عشان تصير الأولويات أدق مع الوقت.',
  },
  benefits: [
    'الأولويات تطلع دقيقة من اليوم الأول',
    'يمنع خروقات SLA قبل ما تصير',
    'يضمن اهتماماً فورياً بعملاء VIP',
    'الفرز اليدوي للأولويات يقل',
    'فريقك يشتغل بكفاءة أعلى',
    'يتعلّم ويتحسّن باستمرار',
  ],
};
